import Panel from './container';

export default Panel;
